module.exports = __webpack_public_path__ + "img/0Q3C0560_Black_MockedUp.20e81be9.jpg";